(function() {
	'use strict';
	angular.module('app.setup')
		.controller('customFieldForm', customFieldForm);

	customFieldForm.$inject = ['$scope', '$uibModal', '$compile', 'projectCustomFieldsService', 'VIEW_PROJECTS', 'storeService'];
	
	function customFieldForm($scope, $uibModal, $compile, projectCustomFieldsService, VIEW_PROJECTS, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		// view model functions
		vm.isDropDownField = false;
		vm.close = close;
		vm.save = save;
		vm.updateField = updateField;
		vm.addFieldValue = addFieldValue;
		vm.deleteFieldValue = deleteFieldValue;
		vm.showEdit = showEdit;
		vm.cancelEdit = cancelEdit;
		vm.saveEdit = saveEdit;
		vm.fieldTypes = [{id: 'TEXT', text: 'Text Field'},{id: 'TEXTAREA', text: 'Text Area'},{id: 'DATE', text: 'Date Field'},
			{id: 'NUMBER', text: 'Number Field'}, {id: 'CURRENCY', text: 'Currency Field'}, {id: 'DROPDOWN', text: 'Drop-Down'}];
		vm.statuses = [{id: 'ENABLED', text: 'Enabled'},{id: 'DISABLED', text: 'Disabled'}];
		
		function init() {
			// init view model project
			
			vm.field = {};
			vm.field.fieldType = 'TEXT';
			vm.field.status = 'ENABLED';
			vm.field.dropdownValues = [];
		}

		function updateField() {
			if (vm.field.fieldType === 'DROPDOWN') {
				vm.isDropDownField = true;
			} else {
				vm.isDropDownField = false;
			}
			vm.field.dropdownValues = [];
		}
		
		function isValueAreadyExists() {
			return vm.field.dropdownValues.map(function (item) {
	            return item.toLowerCase();
	        }).indexOf(vm.fieldValue.toLowerCase());
		}
		
		function save() {
			if (_.indexOf(VIEW_PROJECTS.NATIVE_COLUMNS_NAME, vm.field.name) >= 0) {
				var messageScope = $scope.$new();
				messageScope.messageTitle = 'Alert';
				messageScope.messageText = '"' + vm.field.name + '" is a field name reserved by the system and already ' +
					'exists for every project by default. Please choose a different name.';
				messageScope.buttonText = 'Close';

				var opts = {
					scope: messageScope,
					templateUrl: '/application/f/core/message.html'
				};

				var instance = $uibModal.open(opts);
				messageScope.yes = function() {
					instance.close();
					messageScope.$destroy();
				};
			} else {
				createCustomField();
			}
		}

		function createCustomField() {
			projectCustomFieldsService.addCustomField(vm.field, adminConfig.customer.id).then(function(message) {
				$scope.result(message, message == 'Custom field created successfully');
			});
		}

		function close() {
			$scope.result('', false);
		}
		
		function addFieldValue() {
			if (vm.fieldValue && isValueAreadyExists() === -1) {
				vm.field.dropdownValues.push(vm.fieldValue);
			}
			vm.fieldValue = '';
		}
		
		function deleteFieldValue(index) {
			vm.field.dropdownValues.splice(index, 1);
		}
		
		function getTemplate(position, rowIndex) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			position.left = 20;
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var header = 'Edit Value';
			var scopeModal = 'customFieldFormController.editFieldValue';
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">' + header + '</div>' +
				'<span id="errorMsg" style="color:red;" class="hide"></span>' +
				'<div class="input-holder-with-clear">' +
				'<input class="inlineEditInput with-clear" ng-model="' + scopeModal + '" />' +
				'<span class="input-clear" ng-show="' + scopeModal + ' && ' + scopeModal + '.length" ng-click="' + scopeModal + ' = \'\'"><i class="fa fa-times"></i></span>' +
				'</div>' +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="customFieldFormController.cancelEdit()">Cancel</a>' +
				'<a class="button flat colored" ng-click="(' + scopeModal + ' && ' + scopeModal + '.length>0) && ' + 'customFieldFormController.saveEdit(' + rowIndex + ')">Save</a></div></div>';
			return editTemplate;
		}
		
		init();
		
		function showEdit(index) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#fieldValue' + index);
			var pos = cell.offset();

			var content = cell.text();
			var editTemplate = getTemplate(pos, index);
			var compiledDiv = $compile(editTemplate)($scope);
			vm.editFieldValue = content;
			
			jQuery('#customFieldForm').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					if (vm.editFieldValue == null || strip(vm.editFieldValue) === '') {
						return;
					}
					vm.saveEdit(index, type);
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		};

		
		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		};

		
		function saveEdit(index) {
			var content = strip(vm.editFieldValue);
			
			if (content === '') {
				vm.field.dropdownValues.strip(index, 1);
			} else if (content.toLowerCase() !== vm.field.dropdownValues[index].toLowerCase()) {
				vm.field.dropdownValues[index] = content;
			}
			
			vm.cancelEdit();
		}
	}
})();
